export enum THEMES {
  dark = 'dark',
  light = 'light',
}

const getBrowserTheme = (): THEMES => {
  if (
    window.matchMedia &&
    window.matchMedia('(prefers-color-scheme: light)').matches
  ) {
    return THEMES.light;
  }
  return THEMES.dark;
};
export const defaultTheme = getBrowserTheme();

export enum THEME_NAMES {
  dark = 'Dark Theme',
  light = 'Light Theme',
}

export const THEMES_TO_STORE = Object.entries(THEME_NAMES).map(
  ([value, name]) => ({
    name,
    value,
  })
);
